import { typedQueryClient, useTypedMutation } from "hooks";
import { CarDetailsQueryKeys } from "modules/CarDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DeleteSnoozePayload } from "components";

export const useDeleteSnoozeMutation = () =>
  useTypedMutation<DeleteSnoozePayload, void>({
    mutationFn: async payload => (await ApiInstance.post("/snoozes/delete", payload)).data,
    onSuccess: ({ question_result_id, intervention_id }) => {
      const snoozeItems = typedQueryClient.getQueryData(CarDetailsQueryKeys.snoozeItems);
      if (!snoozeItems?.length) return;

      const remainingSnoozeItems = snoozeItems.filter(
        snoozeItem => snoozeItem.question_result_id !== question_result_id || snoozeItem.intervention_id !== intervention_id
      );
      if (remainingSnoozeItems.length === snoozeItems.length) return;

      typedQueryClient.setQueryData(CarDetailsQueryKeys.snoozeItems, remainingSnoozeItems);
    }
  });
